const RELOAD_AT_KEY = 'bdl_chunk_reload_at';
/** Second failure inside this window shows the shell error instead of looping. */
const RELOAD_COOLDOWN_MS = 15_000;

export function isChunkLoadError(error: unknown): boolean {
  const message = errorMessage(error);
  return /ChunkLoadError|Loading chunk [\w.-]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i.test(message);
}

/**
 * A deploy replaces hashed lazy chunks. The open tab still asks for the old
 * names, the shell stays blank or the next module never mounts, and a reload
 * picks up index.html. One automatic reload per cooldown; a repeat failure
 * must stay on screen so we don't loop.
 */
export function reloadOnceForStaleAssets(reload: () => void = () => window.location.reload()): boolean {
  const now = Date.now();
  try {
    const previous = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    if (Number.isFinite(previous) && now - previous < RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_AT_KEY, String(now));
  } catch {
    return false;
  }
  reload();
  return true;
}

function errorMessage(error: unknown): string {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return `${error.name} ${error.message}`;
  if (typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    const name = 'name' in error ? String((error as { name?: unknown }).name || '') : '';
    return `${name} ${message ?? ''}`.trim();
  }
  return String(error);
}
